import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import Vuetify from 'vuetify/lib';
import VuetifyConfirm from 'vuetify-confirm';
import VueMeta from 'vue-meta';
import LoggedOutLayout from '@/layouts/LoggedOutLayout.vue';
import LoggedInLayout from '@/layouts/LoggedInLayout.vue';
import AppMediumStateFilter from '@/filters/AppMediumStateFilter';
import AppMediumTypeFilter from '@/filters/AppMediumType';
import DayOfWeekFilter from '@/filters/DayOfWeekFilter';
import MonthFilter from '@/filters/MonthFilter';
import DayOfMonthFilter from '@/filters/DayOfMonthFilter';
import FullDateFilter from '@/filters/FullDateFilter';
import FullDateTimeFilter from '@/filters/FullDateTime';
import FullNameFilter from '@/filters/FullName';
import YesNoFilter from '@/filters/YesNo';
import AddressFilter from '@/filters/FullAddress';
import HistoryEntryTypeFilter from '@/filters/HistoryEntryType';
import EntityTypeFilter from '@/filters/EntityType';
import AssociationTypeFilter from '@/filters/AssociationType';
import DebitCreditFilter from '@/filters/DebitCreditFilter';
import RichDataSourceFilter from '@/filters/RichDataSourceFilter';
import CurrencyFilter from '@/filters/Currency';
import LongCurrencyFilter from '@/filters/LongCurrency';
import WebhookEventLayerFilter from '@/filters/WebhookEventLayer';
import DaysInYearFilter from '@/filters/DaysInYearFilter';
import InterestCalculationTypeFilter from '@/filters/InterestCalculationTypeFilter';
import InterestCalculatedOnBalanceTypeFilter from '@/filters/InterestCalculatedOnBalanceTypeFilter';
import RepaymentInterestCalculationTypeFilter from '@/filters/RepaymentInterestCalculationTypeFilter';
import InterestTypeFilter from '@/filters/InterestTypeFilter';
import InterestRateTypeFilter from '@/filters/InterestRateTypeFilter';
import PeriodTypeFilter from '@/filters/PeriodTypeFilter';
import PlanLengthFilter from '@/filters/PlanLengthFilter';
import NonWorkingDaysFilter from '@/filters/NonWorkingDaysFilter';
import PayeeStateFilter from '@/filters/PayeeStateFilter';
import PaymentOrderStateFilter from '@/filters/PaymentOrderStateFilter';
import ScheduleDueDatesTypeFilter from '@/filters/ScheduleDueDatesTypeFilter';
import ScheduleFrequencyFilter from '@/filters/ScheduleFrequencyFilter';
import PostingScheduleTypeFilter from '@/filters/PostingScheduleTypeFilter';
import PostedFrequencyTypeFilter from '@/filters/PostedFrequencyTypeFilter';
import PayeeTypeFilter from '@/filters/PayeeTypeFilter';
import PaymentStateFilter from '@/filters/PaymentStateFilter';
import ProductFeeDefinitionTypeFilter from '@/filters/ProductFeeDefinitionTypeFilter';
import ProductTypeFilter from '@/filters/ProductTypeFilter';
import ProductSubTypeFilter from '@/filters/ProductSubTypeFilter';
import ProductStateFilter from '@/filters/ProductStateFilter';
import ProductIssueStateFilter from '@/filters/ProductIssueStateFilter';
import ProductMigrationStateFilter from '@/filters/ProductMigrationStateFilter';
import ProductMigrationLogStateFilter from '@/filters/ProductMigrationLogStateFilter';
import WalletStateFilter from '@/filters/WalletStateFilter';
import LedgerStateFilter from '@/filters/LedgerStateFilter';
import MandateStateFilter from '@/filters/MandateStateFilter';
import CustomerAccountStateFilter from '@/filters/CustomerAccountStateFilter';
import FeeStateFilter from '@/filters/FeeStateFilter';
import PaymentOrderFeeStateFilter from '@/filters/PaymentOrderFeeStateFilter';
import CustomerAccountStateReasonCodeFilter from '@/filters/CustomerAccountStateReasonCodeFilter';
import InstitutionAccountStateFilter from '@/filters/InstitutionAccountStateFilter';
import InstitutionStateFilter from '@/filters/InstitutionStateFilter';
import BankingIntegrationFilter from '@/filters/BankingIntegrationFilter';
import CardIntegrationFilter from '@/filters/CardIntegrationFilter';
import TransactionMonitoringIntegrationFilter from '@/filters/TransactionMonitoringIntegrationFilter';
import GeneralLedgerAccountTypeFilter from '@/filters/GeneralLedgerAccountTypeFilter';
import GeneralLedgerAccountStateFilter from '@/filters/GeneralLedgerAccountStateFilter';
import TargetCustomerTypeFilter from '@/filters/TargetCustomerTypeFilter';
import FixedTermMaturityTypeFilter from '@/filters/FixedTermMaturityTypeFilter';
import FixedTermMaturityActionTypeFilter from '@/filters/FixedTermMaturityActionTypeFilter';
import FundingWindowTriggerTypeFilter from '@/filters/FundingWindowTriggerTypeFilter';
import ShortMonthHandlingTypeFilter from '@/filters/ShortMonthHandlingTypeFilter';
import WalletFxDemoFilter from '@/filters/WalletFxDemoFilter';
import AppConsts from '@/lib/appConstants';
//@ts-ignore
import JsonViewer from 'vue-json-viewer'
//@ts-ignore
import VCurrencyField from 'v-currency-field';
import { VTextField } from 'vuetify/lib';  //Globally import VTextField
import PermissionUtils from './lib/permissionUtils';
import OpenEntityInNewWindowButton from '@/components/Shared/OpenEntityInNewWindowButton.vue';
import OpenEntityInCurrentWindowLink from '@/components/Shared/OpenEntityInCurrentWindowLink.vue';
import { messages, defaultLocale } from "@/i18n";
import VueI18n from 'vue-i18n';
import FieldLabel from '@/components/Shared/FieldLabel.vue';

// Initialise Shared Components
Vue.component('field-label', FieldLabel);
Vue.component('logged-in-layout', LoggedInLayout);
Vue.component('logged-out-layout', LoggedOutLayout);
Vue.component('open-entity-in-new-window-button', OpenEntityInNewWindowButton);
Vue.component('open-entity-in-current-window-link', OpenEntityInCurrentWindowLink);
// Initialise Filters
Vue.filter('AppMediumState', AppMediumStateFilter);
Vue.filter('AppMediumType', AppMediumTypeFilter);
Vue.filter('FullDate', FullDateFilter);
Vue.filter('FullDateTime', FullDateTimeFilter);
Vue.filter('FullAddress', AddressFilter);
Vue.filter('FullName', FullNameFilter);
Vue.filter('Currency', CurrencyFilter);
Vue.filter('LongCurrency', LongCurrencyFilter);
Vue.filter('DebitCredit', DebitCreditFilter);
Vue.filter('RichDataSource', RichDataSourceFilter);
Vue.filter('HistoryEntryType', HistoryEntryTypeFilter);
Vue.filter('YesNo', YesNoFilter);
Vue.filter('WebhookEventLayer', WebhookEventLayerFilter);
Vue.filter('ProductIssueState', ProductIssueStateFilter);
Vue.filter('ProductMigrationState', ProductMigrationStateFilter);
Vue.filter('ProductMigrationLogState', ProductMigrationLogStateFilter);
Vue.filter('ProductState', ProductStateFilter);
Vue.filter('InstitutionState', InstitutionStateFilter);
Vue.filter('BankingIntegration', BankingIntegrationFilter);
Vue.filter('CardIntegration', CardIntegrationFilter);
Vue.filter('TransactionMonitoringIntegration', TransactionMonitoringIntegrationFilter);
Vue.filter('ProductType', ProductTypeFilter);
Vue.filter('ProductSubType', ProductSubTypeFilter);
Vue.filter('WalletState', WalletStateFilter);
Vue.filter('LedgerState', LedgerStateFilter);
Vue.filter('MandateState', MandateStateFilter);
Vue.filter('DaysInYear', DaysInYearFilter);
Vue.filter('NonWorkingDays', NonWorkingDaysFilter);
Vue.filter('PeriodType', PeriodTypeFilter);
Vue.filter('PlanLength', PlanLengthFilter);
Vue.filter('DayOfWeek', DayOfWeekFilter);
Vue.filter('Month', MonthFilter);
Vue.filter('DayOfMonth', DayOfMonthFilter);
Vue.filter('InterestType', InterestTypeFilter);
Vue.filter('InterestRateType', InterestRateTypeFilter);
Vue.filter('InterestCalculationType', InterestCalculationTypeFilter);
Vue.filter('InterestCalculatedOnBalanceType', InterestCalculatedOnBalanceTypeFilter);
Vue.filter('RepaymentInterestCalculationType', RepaymentInterestCalculationTypeFilter);
Vue.filter('PayeeState', PayeeStateFilter);
Vue.filter('PaymentOrderState', PaymentOrderStateFilter);
Vue.filter('ScheduleDueDatesType', ScheduleDueDatesTypeFilter);
Vue.filter('ScheduleFrequency', ScheduleFrequencyFilter);
Vue.filter('PostingScheduleType', PostingScheduleTypeFilter);
Vue.filter('PostedFrequencyType', PostedFrequencyTypeFilter);
Vue.filter('PayeeType', PayeeTypeFilter);
Vue.filter('PaymentState', PaymentStateFilter);
Vue.filter('ProductFeeDefinitionType', ProductFeeDefinitionTypeFilter);
Vue.filter('CustomerAccountState', CustomerAccountStateFilter);
Vue.filter('CustomerAccountStateReasonCode', CustomerAccountStateReasonCodeFilter);
Vue.filter('InstitutionAccountState', InstitutionAccountStateFilter);
Vue.filter('FeeState', FeeStateFilter);
Vue.filter('PaymentOrderFeeState', PaymentOrderFeeStateFilter);
Vue.filter('GeneralLedgerAccountType', GeneralLedgerAccountTypeFilter);
Vue.filter('GeneralLedgerAccountState', GeneralLedgerAccountStateFilter);
Vue.filter('TargetCustomerType', TargetCustomerTypeFilter);
Vue.filter('EntityType', EntityTypeFilter);
Vue.filter('AssociationType', AssociationTypeFilter);
Vue.filter('FixedTermMaturityType', FixedTermMaturityTypeFilter);
Vue.filter('FixedTermMaturityActionType', FixedTermMaturityActionTypeFilter);
Vue.filter('FundingWindowTriggerType', FundingWindowTriggerTypeFilter);
Vue.filter('ShortMonthHandlingType', ShortMonthHandlingTypeFilter);
Vue.filter('WalletFxDemo', WalletFxDemoFilter);

// Check for a previously saved user preference
const displayMode = localStorage.getItem("saascada-display-mode") ? localStorage.getItem("saascada-display-mode") : null;
// Calculate which mode to use based on saved preference, defaults to light mode (eg. useDarkMode = false)
let useDarkMode = false;
if (displayMode === "BROWSER") {
    useDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
}
else if (displayMode === "DARK") {
    useDarkMode = true;
}

const vuetify = new Vuetify({
    theme: {
        dark: useDarkMode,
        themes: {
            light: {
                primary: AppConsts.theme.light.primary,
                secondary: AppConsts.theme.light.secondary,
                error: AppConsts.theme.light.error,
                background: AppConsts.theme.light.background
            },
            dark: {
                primary: AppConsts.theme.dark.primary,
                secondary: AppConsts.theme.dark.secondary,
                error: AppConsts.theme.dark.error,
                background: AppConsts.theme.dark.background
            }
        }
    }
});

Vue.use(JsonViewer);
Vue.use(Vuetify);
Vue.use(VuetifyConfirm, { vuetify });
Vue.use(VueMeta);
Vue.use(VCurrencyField, {
    locale: 'en-GB',
    decimalLength: 2,
	autoDecimalMode: true,
	min: null,
	max: null,
	defaultValue: 0,
    valueAsInteger: true,
    allowNegative: false
});

Vue.component('v-text-field', VTextField);

Vue.mixin({
    methods: {
        hasPermission: (permission) => PermissionUtils.hasPermission(permission)
    }
});

// Check browser storage for a preferred language, if not found fallback to the default
Vue.use(VueI18n);
const preferredLanguage = localStorage.getItem("saascada-preferred-language") ? localStorage.getItem("saascada-preferred-language") : defaultLocale;
const i18n = new VueI18n({
    messages,
    locale: preferredLanguage,
    fallbackLocale: defaultLocale
});
// Export the i18n object so we can import it into other files and use translation
export default i18n;

new Vue({
    i18n,
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
